import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { validateName, validatePhoneNumber } from "../utils/validation";
import { handleFormSubmit } from "../handlers/formHandlers";
import PhoneNumberInput from "../components/PhoneNumberInput";
import BenefitPeriod from "../components/BenefitPeriod";
import PrivacyPolicyAgree from "../components/PrivacyPolicyAgree";
import {
  options,
  phoneFirstOptions,
  prohibitedWords,
} from "../utils/dummyData";

import "./randingStyle1.scss";
import PrivacyContent from "./PrivacyContent";

function RandingStyle16({
  urlCode,
  urlCodeSettingId,
  totalStep,
  changedIMG,
  img1Path,
  img2Path,
  img3Path,
  img4Path,
  formFieldColor,
  qContainer1Path,
  qContainer2Path,
  qOptionImgPath,
  optionsArray,
  qOptions,
  qOptionColor,
  questionType,
  keepBTN,
  postBTN,
  companyName,
  footerPath,
  // 랜딩 별로 태그 설정인 경우

  articleOption,
  privacyMessage,
  propsBackgroundColor,
  addStyle,
  apiUrl,
  kakaotalk,
  carrotTag,
}) {
  const navigate = useNavigate();
  // 상태 관리
  const [name, setName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false); // 버튼 상태 관리
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });
  const [selectedOption, setSelectedOption] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const handleSelectImplant = (option) => {
    setSelectedOption(option);
    console.log(option);
  };

  const nextStep = () => {
    if (currentStep < 2) setCurrentStep(currentStep + 1);
  };

  const togglePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModal(!isPrivacyPolicyModal);
  };

  const handleSubmit = () => {
    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,

      apiUrl,
      kakaotalk,
      carrotTag,
    });
  };

  return (
    <form
      className="form-container"
      onSubmit={(e) => {
        e.preventDefault(); // 기본 제출 동작 방지
        handleSubmit(); // 기존 handleSubmit 호출
      }}
      style={{ backgroundColor: propsBackgroundColor }}
    >
      {totalStep == 2 && currentStep === 1 && (
        <div className="step1">
          {img1Path && <img src={img1Path} />}
          <div className="rel">
            {articleOption && (
              <p className="notice-limited-event" style={{ ...addStyle }}>
                ※{new Date().getMonth() + 1}월 한정 이벤트 입니다※
                <br />
                ※위 이벤트는 조기종료될 수 있습니다※
              </p>
            )}
            {img2Path && (
              <img
                src={img2Path}
                alt="임플란트 최대 비용 혜택 의료법상 49% 최대할인"
              />
            )}
          </div>
          <div className="qBox">
            <div style={{ width: "105%" }} className={`questionContainer rel`}>
              <img src={qContainer1Path} />
              <div
                style={{ bottom: "12%", gap: optionsArray && "10px" }}
                className={`qOptions absol ${
                  optionsArray ? optionsArray : "row"
                }`}
              >
                {(qOptions || options).map((option, index) => (
                  <img
                    key={index}
                    src={`${qOptionImgPath}/${
                      selectedOption === option
                        ? `qoption${index + 1}(1)`
                        : `qoption${index + 1}`
                    }.png`}
                    alt={option}
                    onClick={() => handleSelectImplant(option)}
                  />
                ))}
              </div>
            </div>
          </div>
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          <div className="sendBtnBox">
            <img src={keepBTN} alt="계속하기" onClick={nextStep} />
          </div>
        </div>
      )}
      {(totalStep == 1 || currentStep === 2) && (
        <div className="step2">
          {img1Path && <img src={img1Path} />}
          <div className="rel">
            {articleOption && (
              <p className="notice-limited-event" style={{ ...addStyle }}>
                ※{new Date().getMonth() + 1}월 한정 이벤트 입니다※
                <br />
                ※위 이벤트는 조기종료될 수 있습니다※
              </p>
            )}
            {img2Path && (
              <img
                src={changedIMG ? changedIMG : img2Path}
                alt="임플란트 최대 비용 혜택 의료법상 49% 최대할인"
              />
            )}
          </div>
          <div className="qBox">
            <div className={`questionContainer rel`} style={{ width: "105%" }}>
              <img src={qContainer2Path ? qContainer2Path : qContainer1Path} />
              <div className="formBox" style={{ left: "4%" }}>
                <div className={`formField`}>
                  <label htmlFor="name">이름</label>
                  <input
                    type="text"
                    id="name"
                    maxLength="10"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>

                <PhoneNumberInput
                  phoneNumber={phoneNumber}
                  phoneFirstOptions={phoneFirstOptions}
                  handlePhoneNumberChange={handlePhoneNumberChange}
                  formFieldColor={formFieldColor}
                />
              </div>
            </div>
          </div>
          <button type="submit" className="sendBtnBox" disabled={isSubmitting}>
            <img src={postBTN} alt="신청하기" />
          </button>
          <div className="privacyBenefitBox">
            <p className="benefitInfo">
              <BenefitPeriod />
              <br />
              이벤트 대상자 : 해당 매체 이용자
            </p>
            <PrivacyPolicyAgree
              isAgreed={isAgreed}
              setIsAgreed={setIsAgreed}
              togglePrivacyPolicyModal={togglePrivacyPolicyModal}
              privacyMessage={privacyMessage}
            />
            {isPrivacyPolicyModal && (
              <div className="modalOverlay" onClick={togglePrivacyPolicyModal}>
                <div
                  className="privacyPolicyContent"
                  onClick={(e) => e.stopPropagation()}
                >
                  <PrivacyContent companyName={companyName} />
                </div>
              </div>
            )}
          </div>
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
        </div>
      )}
      <div className="footer">
        {footerPath && <img src={footerPath} alt="푸터" />}{" "}
      </div>
    </form>
  );
}

export default RandingStyle16;
